// Copyright (c) 2016 Deere & Company

import {
    addFile,
    deleteFile
} from './file-attachment';
import {
    addLabor,
    changeLaborLocation,
    changeLaborProperty,
    changeLaborType,
    deleteLabor
} from './labor';
import {
    addPart,
    changePartProperty,
    changePartsUnit,
    deletePart
} from './parts';
import {
    changeAmount,
    changeComments,
    changeDescription,
    changeDistance,
    createOtherCredit,
    deleteOtherCredit
} from './other-credits';
import {
    onCreateClaim,
    updateClaimModalMode,
    updateCreateClaimModalVisibility
} from './create-claim-modal-visibility';
import {
    resetConfirmationModal,
    setConfirmationModal
} from './confirmation-modal';
import {
    resetPartsClaim,
    resetPartsProductDetails,
    updateInstalledByDropDown,
    updateOwnershipStatusDropDown,
    updatePartsClaimFailureDate,
    updatePartsClaimFailurePart,
    updatePartsClaimInputOnBlur,
    updatePartsClaimPartUseAmount,
    updatePartsClaimPartUseUnitDropDown,
    updatePartsClaimPin,
    updatePartsClaimProperty,
    updatePartsClaimRepairDate,
    updatePartsClaimRepairNumber,
    updatePartsClaimUnitDropDown,
    updatePartsClaimUseAmount,
    updatePartsClaimWorkOrderOne,
    updatePartsClaimWorkOrderTwo,
    updateResponsibleAccountsDropDown,
    updateStickyHeaderVisibility
} from './claim-details';
import {
    updateDownTimeDropDown,
    updateFailedModeDropDown,
    updatePartsClaimBasisForSettlement,
    updatePartsClaimComplaintCause,
    updatePartsClaimComplaintCorrection,
    updatePartsClaimDtacCase,
    updatePartsClaimDtacSolution,
    updatePartsClaimFailedArea,
    updatePartsClaimFailedModeComments,
    updatePartsClaimOperatorComments,
    updatePartsClaimOperatorsComplaint,
    updatePartsClaimPartSerialNumber
} from './failure-panel';
import {additionalRepair} from './additional-repair';
import {copyAttachments} from '../../shared/action-creators/copy-attachment';
import {copyClaim} from './copy-claim';
import {createPartsClaim} from './validate-claim';
import {onEditClaim} from '../../shared/action-creators/edit-claim';
import {readClaimProduct} from './get-product-details';
import {readClaimTypes} from './get-claim-types';
import {readDownTime} from '../../shared/action-creators/down-time';
import {readFailureModes} from './failure-modes';
import {readGoodsInstallationVatOptions} from '../../shared/action-creators/get-goods-installation-vat-options';
import {readInstalledBy} from './get-installed-by';
import {readLaborLocations} from '../../shared/action-creators/labor-locations';
import {readLaborTypes} from '../../shared/action-creators/labor-types';
import {readOtherCreditDescriptions} from '../../shared/action-creators/other-credit-descriptions';
import {readOwnershipStatuses} from '../../shared/action-creators/ownership-status';
import {readPartDetails} from './get-part-details';
import {readPartUseUnits} from '../../shared/action-creators/part-use-units';
import {readPartsClaim} from './get-parts-claim';
import {resetCkcCustomerFailure} from '../../../shared/action-creators/customer-failed';
import {resetCustomerDetails} from './reset-customer-details';
import {resetLatestPerUnitMeasurements} from '../../../shared/action-creators/latest-per-unit-measurements';
import {toggleWarrentyStatusModal} from '../../shared/action-creators/warranty-status-modal';
import {updateGoodsInstallationVat} from './update-goods-installation-vat';
import {updateIsEditable} from './is-editable';
import {updatePartType} from './part-types';
import {updateSelectedAction} from './update-selected-action';
import {updateTemporaryObjectKey} from './update-temporary-object-key';
import {updateWarranties} from '../../../product/details/action-creators/warranties';

export default {
    addFile,
    addLabor,
    addPart,
    additionalRepair,
    changeAmount,
    changeComments,
    changeDescription,
    changeDistance,
    changeLaborLocation,
    changeLaborProperty,
    changeLaborType,
    changePartProperty,
    changePartsUnit,
    copyAttachments,
    copyClaim,
    createOtherCredit,
    createPartsClaim,
    deleteFile,
    deleteLabor,
    deleteOtherCredit,
    deletePart,
    onCreateClaim,
    onEditClaim,
    readClaimProduct,
    readClaimTypes,
    readDownTime,
    readFailureModes,
    readGoodsInstallationVatOptions,
    readInstalledBy,
    readLaborLocations,
    readLaborTypes,
    readOtherCreditDescriptions,
    readOwnershipStatuses,
    readPartDetails,
    readPartUseUnits,
    readPartsClaim,
    resetCkcCustomerFailure,
    resetConfirmationModal,
    resetCustomerDetails,
    resetLatestPerUnitMeasurements,
    resetPartsClaim,
    resetPartsProductDetails,
    setConfirmationModal,
    toggleWarrentyStatusModal,
    updateClaimModalMode,
    updateCreateClaimModalVisibility,
    updateDownTimeDropDown,
    updateFailedModeDropDown,
    updateGoodsInstallationVat,
    updateInstalledByDropDown,
    updateIsEditable,
    updateOwnershipStatusDropDown,
    updatePartType,
    updatePartsClaimBasisForSettlement,
    updatePartsClaimComplaintCause,
    updatePartsClaimComplaintCorrection,
    updatePartsClaimDtacCase,
    updatePartsClaimDtacSolution,
    updatePartsClaimFailedArea,
    updatePartsClaimFailedModeComments,
    updatePartsClaimFailureDate,
    updatePartsClaimFailurePart,
    updatePartsClaimInputOnBlur,
    updatePartsClaimOperatorComments,
    updatePartsClaimOperatorsComplaint,
    updatePartsClaimPartSerialNumber,
    updatePartsClaimPartUseAmount,
    updatePartsClaimPartUseUnitDropDown,
    updatePartsClaimPin,
    updatePartsClaimProperty,
    updatePartsClaimRepairDate,
    updatePartsClaimRepairNumber,
    updatePartsClaimUnitDropDown,
    updatePartsClaimUseAmount,
    updatePartsClaimWorkOrderOne,
    updatePartsClaimWorkOrderTwo,
    updateResponsibleAccountsDropDown,
    updateSelectedAction,
    updateStickyHeaderVisibility,
    updateTemporaryObjectKey,
    updateWarranties
};



// WEBPACK FOOTER //
// ./src/claim/parts/action-creators/index.js